fx.ns("desktop.calendar", class CalendarStartingMonth  extends fx.Component
{
    constructor(data)
    {
        super(data);

        this.showClose = false;
    }

    create()
    {
        super.create();

        this.cancelButton = new fx.components.Button({label : "< " + fx.text("Revenir"), className : "cancel"});
        this.addChild(this.cancelButton, {height:30, left:10, top : 0});

        let container = new fx.components.Box();

        this.circlesBox = new shared.component.Person(fx.get("assets").personAsset);
        container.addChild(this.circlesBox, {width:260, height : 260, top :  0, left : "center"});

        let textLabel = new fx.components.Text({text : fx.text("Choisissez le mois de démarrage de votre calendrier"), className : "label center"});
        container.addChild(textLabel, { top : 280, left :"center", width : "100%"});

        this.monthInputBox = new fx.components.Box("month-input");

        this.monthInput = new fx.components.Text({ className : "month-label" });
        this.monthInputBox.addChild( this.monthInput, { left : "center", top : "center", width : "100%", height : 28});

        this.monthIcon = new fx.components.Image(fx.assets.calendarIcon);
        this.monthInputBox.addChild( this.monthIcon, { right : 15, top : "center", width : 20, height : 20});

        container.addChild(this.monthInputBox, { top : 330, left : "center", width : 500, height : 50});

        this.datePicker = new fx.components.DatePicker({defaultDate : this.bestStartingMonth, pickLevel : 1, maxView : 1, minDate : new Date( Date.currentYear(), 0,1), maxDate : new Date( Date.currentYear()+2, 0,0) });
        this.datePicker.visibleAtStart = false;
        this.datePicker.effect = "vslide";
        container.addChild(this.datePicker, { left: "center", top:330, width : 500, height : 295 });

        this.validateButton = new fx.components.Button({label : fx.text("Commencer"), className : "validate filled"});
        container.addChild(this.validateButton, {height:50, width : 250, left:"center", top : 395});

        this.addChild(container, {width : 600, height : 670, top : "center", left : "center"});

        
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onValidate, this.validateButton);
        this.on("click", this.onCancel, this.cancelButton);

        this.on("click", this.onMonthInput, this.monthInputBox);
        this.on("changed", this.onDatePickerChanged, this.datePicker);

        this._updateMonthInput(this.bestStartingMonth);
    }

    get bestStartingMonth()
    {
        let date = new Date();

        // Janvier - Mai => Janvier
        // Mai - Oct => Septembre
        // Nov - Décembre => Janvier année d'après

        // between february and August, propose January by default
        if (date.getMonth() >= 0 && date.getMonth() < 4)
        {
            date.setMonth( 0 );
        }
        else
        if (date.getMonth() >= 4 && date.getMonth() <= 9)
        {
            date.setMonth( 8 );
        }
        else
        {   
            date = new Date(date.getFullYear() + 1, 0);
        }

        return date;
    }

    onValidate()
    {
        let date = this.datePicker.selectedDate || this.bestStartingMonth;
        this.data.creation.setStartingMonth(date);
        this.data.event("next-step");
    }

    onCancel()
    {
        this.data.event("previous-step");
    }

    onMonthInput()
    {
        this.monthInputBox.hide();
        this.datePicker.show();
    }

    onDatePickerChanged()
    {
        this.monthInputBox.show();
        this.datePicker.hide();

        this._updateMonthInput(this.datePicker.selectedDate);
    }

    _updateMonthInput(date)
    {
        this.monthInput.text = fx.text( Date.currentMonth(date).capitalize() ) + " " + Date.currentYear(date); 
    }
});